export default {
    title: state => {
        return state.title;
    },
    cities: state => {
        return state.cities;
    },
    city: state => {
        return state.city;
    },
    issuedCities: state => {
        return state.issuedCities;
    },
    birthCities: state => {
        return state.birthCities;
    },
    cityToEdit: state => {
        return state.cityToEdit;
    },
    total: state => {
        return state.total;
    },
    province: state => {
        return state.province;
    },
    status: state => {
        return state.status;
    },

}
